import styled from 'styled-components';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Card/CardBody');

/**
 * Помещается в ``<Card />`` и скругляет рамки содержимого внутри него.
 * Обязательно к использованию для корректного отображения скругленных углов контента.
 */
export var CardBody = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-ybi9yl-0"
})(["position:relative;display:flex;overflow:hidden;flex:1;flex-direction:column;box-sizing:content-box;width:100%;border-radius:inherit;"]);